
import { type AssetHandler } from '../../assetTypes';
import { type IAssetFile } from '../assetHandler';

import type { DropPayload } from '@/editor/core/dragDropTypes';
import type * as THREE from 'three';

import { store } from '@/app/editor/store';

const canSelectFolders = true;

/**
 * Default handler for assets that don't have a specific handler
 */
export class DefaultHandler implements AssetHandler {
  async handleSelect(asset: IAssetFile): Promise<void> {
    console.log(`Default handler select: ${asset.name}`);
    store.setSelectedAssetItem((canSelectFolders || !asset.isFolder) ? asset : undefined);
  }

  async handleOpen(asset: IAssetFile): Promise<void> {
    console.log(`Default handler open: ${asset.name}`);
  }

  async handleDrop(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    const asset = payload.payload;
    console.log(`Default handler drop: ${asset.name}`);
  }

  async handleDragEnter(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    console.log(`Default handler drag enter: ${payload.payload.name}`);
  }

  async handleDragOver(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    console.log(`Default handler drag over: ${payload.payload.name}`);
  }

  async handleDragCancel(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
    console.log(`Default handler drag cancel: ${payload.payload.name}`);
  }

  getTargetObject(): unknown {
    return undefined;
  }
}
